module.exports = __webpack_public_path__ + "static/media/sideATP2.3cf9a0b9.jpg";